import { observer } from 'mobx-react'
import React from 'react'
import {
  Modal,
  message
  // Select
} from 'antd'
import { getStores } from '@/stores'
import { createSessionIdNewAPI } from '@/servers/agent-v2'
import useInitHistroy from '../../hooks/use-init-histroy'
import { getChatList } from '@/servers/agent-v2'
import { $t } from '@/i18n/intl'
import LeftAnimateWrapper from '../../components/left-animate-wrapper'
import styles from './index.module.scss'
import cn from 'classnames'
import logo from './logo.svg'
import OpacityAnimateWrapper from '../../components/opacity-animate-wrapper'
import videoCameraIcon from '@/assets/images/video-on.svg'
import VideoLibraryLayer from './video-library-layer'

const Menu = () => {
  const { agentV2Store } = getStores()
  // const { currentLang } = useI18nStore()
  const [chatList, setChatList] = React.useState<
    {
      session_id: string
      session_name: string
      start_time: string
    }[]
  >([])

  const loading = agentV2Store.chatLoadingState.loading || agentV2Store.typing

  const { initHistory } = useInitHistroy({
    autofetch: false
  })

  // const languageOptions = [
  //   { label: '中文', value: 'zh-CN' },
  //   { label: 'English', value: 'en-US' }
  // ]

  // 获取历史对话列表
  React.useEffect(() => {
    agentV2Store.isInitSessionList = false
    getChatList({
      page_size: 10
    })
      .then(res => {
        if (res.code === 0) {
          setChatList(res.data.list || [])
          agentV2Store.sessionList = res.data.list || []
          agentV2Store.isInitSessionList = true
        }
      })
      .catch(() => {
        agentV2Store.isInitSessionList = true
      })
  }, [])

  // 新建对话
  const handleNewConversation = () => {
    if (loading) {
      message.warning($t('demo.menu.createNewDialog.cannotCreateInMode'))
      return
    }

    Modal.confirm({
      title: $t('demo.menu.createNewDialog.title'),
      content: $t('demo.menu.createNewDialog.content'),
      okText: $t('demo.menu.createNewDialog.confirm'),
      cancelText: $t('demo.menu.createNewDialog.cancel'),
      onOk: async () => {
        try {
          const res = await createSessionIdNewAPI()
          if (res.code === 0) {
            await initHistory()
            message.success($t('demo.menu.createNewDialog.success'))
            agentV2Store.isHistoryChatMode = false
            // 刷新历史对话列表
            getChatList({
              page_size: 10
            }).then(res => {
              if (res.code === 0) {
                setChatList(res.data.list || [])
              }
            })
          } else {
            message.error($t('demo.menu.createNewDialog.error'))
          }
        } catch (error) {
          console.error('Create session error:', error)
          message.error($t('demo.menu.createNewDialog.error'))
        }
      }
    })
  }

  // 历史对话点击
  const handleHistoryClick = async (session_id: string) => {
    if (loading) {
      message.warning($t('demo.menu.historyMode.cannotSwitch'))
      return
    }

    await initHistory(session_id)
    // 点击的是 getSessionIdNewAPI 返回的最新会话时，视为在最新对话中，不进入历史记录浏览模式
    agentV2Store.isHistoryChatMode = session_id !== agentV2Store.latestSessionId
  }

  return (
    <div className={styles.menuBox}>
      {/* 顶部区域：Logo 和新建按钮 */}
      <div className={styles.topSection}>
        <OpacityAnimateWrapper>
          <img className={styles.logo} src={logo} alt="logo" />
        </OpacityAnimateWrapper>
        <LeftAnimateWrapper>
          <button className={styles.newButton} onClick={handleNewConversation}>
            {$t('demo.menu.newConversationButton')}
          </button>
        </LeftAnimateWrapper>
      </div>
      {/* 历史对话区域 */}
      <LeftAnimateWrapper>
        <div className={styles.historySection}>
          <div className={styles.historyTitle}>{$t('demo.menu.historicalDialogue')}</div>
          <div className={styles.historyList}>
            {chatList.length > 0 ? (
              [...chatList]
                // .reverse()
                .slice(0, 10)
                .map(item => (
                  <div
                    key={item.session_id}
                    className={cn(styles.historyItem, {
                      [styles.selected]: item.session_id === agentV2Store.currentSessionId
                    })}
                    onClick={() => handleHistoryClick(item.session_id)}
                  >
                    {item.session_name || $t('demo.menu.untitledConversation')}
                  </div>
                ))
            ) : (
              <div className={styles.emptyHistory}>{$t('demo.menu.emptyHistory')}</div>
            )}
          </div>
        </div>
      </LeftAnimateWrapper>

      <div className={styles.videoLibraryEntry}>
        <a
          className={styles.link}
          href="#"
          onClick={e => {
            e.preventDefault()
            agentV2Store.setVideoLibraryVisible(true)
          }}
        >
          <img className={styles.icon} src={videoCameraIcon} alt="" aria-hidden />
          <span className={styles.text}>{$t('demo.menu.videoDatabase')}</span>
        </a>
      </div>
      <VideoLibraryLayer
        visible={agentV2Store.videoLibraryVisible}
        onClose={() => agentV2Store.setVideoLibraryVisible(false)}
      />
      {/* 语言切换区域 */}
      {/* <div className={styles.languageSection}>
        <Select
          value={(currentLang as LanguagesType) || 'en-US'}
          className={styles.languageSelect}
          size="small"
          options={languageOptions}
          onChange={(lang: LanguagesType) => {
            window.location.href = window.location.origin + '/aigc' + `?locale=${lang}`
          }}
        />
      </div> */}
    </div>
  )
}

export default observer(Menu)
